module.exports = __webpack_public_path__ + "static/48gde-656af30b1e3f0b94597e98991483bdfa.gif";